import { render, staticRenderFns } from "./TransportReference.vue?vue&type=template&id=5669a87c"
import script from "./TransportReference.vue?vue&type=script&lang=js"
export * from "./TransportReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports